import { rootMargin } from '@helpers/animate';
import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { highlightTitleWords } from '@helpers/utils';
import { useInView } from '@hooks/useInView';
import SvgChevron from '@img/icons/menu-chevron-right.svg';
import LinkButton from '@stories/Components/Global/Buttons/LinkButton/LinkButton';
import * as React from 'react';
import S from './CtaBanner.styles';
const CtaBanner = (props) => {
    const [elementRef, inView] = useInView({ rootMargin }, false, props.pageContext?.isEditMode);
    if (!props.image && !props.title) {
        return null;
    }
    const srcs = props.variant === 'full-width'
        ? getSrcs(props.image, 1920, 375, 6, props.site)
        : getSrcs(props.image, 1033, 375, 7, props.site, props.variant === 'secondary' && props.site === 'mep' ? undefined : 1083 / 653);
    const sizes = `${until(Device.TabletLarge)} 100vw, ${until(Device.ActualDesktop)} 55vw, 1033px`;
    return (React.createElement(S.Container, { id: props.anchorId ?? props.id, ref: elementRef, "data-align": props.imageAlignment, "data-animate": inView, "data-animation-variant": `${props.site}-${props.variant}-${props.imageAlignment}-${inView}`, "data-variant": props.variant, site: props.site, spacing: 'none' },
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.Title, { dangerouslySetInnerHTML: { __html: highlightTitleWords(props.title) } }),
            React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }),
            (props.cta || props.cta2) && (React.createElement(S.CtaWrapper, null,
                props.cta && (React.createElement(LinkButton, { buttonType: `${props.site === 'mep'
                        ? props.variant === 'primary'
                            ? 'secondary'
                            : 'outline'
                        : 'secondary'}`, href: props.cta.url, target: props.cta.target, site: props.site }, props.cta.text)),
                props.cta2 && (React.createElement(LinkButton, { buttonType: `${props.site === 'mep'
                        ? props.variant === 'primary'
                            ? 'secondary'
                            : 'default'
                        : 'outline'}`, href: props.cta2.url, target: props.cta2.target, site: props.site }, props.cta2.text)))),
            props.variant === 'tertiary' && props.site !== 'mep' && (React.createElement(S.ChevronWrapper, null,
                React.createElement(SvgChevron, null)))),
        props.variant === 'tertiary' && props.site === 'ess' ? React.createElement(S.Line, null) : null,
        props.image && (React.createElement(React.Fragment, null, props.variant === 'full-width' ? (React.createElement(S.FullWidthImage, null,
            React.createElement("img", { src: srcs[0].split(' ')[0], srcSet: srcs.join(','), alt: props.image.altText, role: !props.image.altText ? 'presentation' : undefined, loading: "lazy" }))) : (React.createElement(S.ImageWrapper, null,
            React.createElement(S.ImageInner, null,
                props.variant === 'primary' && props.site !== 'mep' && (React.createElement(S.ChevronWrapper, null,
                    React.createElement(SvgChevron, null))),
                React.createElement(S.ImageShape, null,
                    React.createElement(S.Image, { src: srcs[0].split(' ')[0], srcSet: srcs.join(','), sizes: sizes, alt: props.image.altText, role: !props.image.altText ? 'presentation' : undefined, loading: "lazy" })))))))));
};
export default CtaBanner;
